import { AppConfig, B2CConfig, NexusConfig, AADConfig } from '@virtus/common/auth';
//import { AppConfig, B2CConfig, NexusConfig } from '@virtus/common/src/auth';
import { IDPConfig } from '@virtus/common/auth';
import { DefaultProfileConfig } from 'src/comps/UserProfile/UserProfile';

export interface AdminAppConfig extends Required<AppConfig> {
  b2c: B2CConfig;
  adminConfig: NexusConfig;
  defaultProfile: DefaultProfileConfig;
  appInsightsKey: string;
  unauthorizedTextMessage: string;
  storageAccount: string;
  container: string;
  idp: IDPConfig;
  useIDP: boolean;
  aad: AADConfig;
  useAD: boolean;
}

/**
 * returns correct Config object depending on __ENVIRONMENT__
 *
 * Using "if" statements other environments should be tree-shaked by webpack and not appear in bundled js
 */
const getConfig = (): AdminAppConfig => {
  if (__ENVIRONMENT__ === 'local' || __ENVIRONMENT__ === 'dev') {
    return {
     useIDP: false,
     useAD: true,     
      adminConfig: {
        baseURL: 'https://devnext.virtusllc.net/VirtusAdminAppApi',
        signalrUrl: 'https://devnext.virtusllc.net/SignalR/SignalRHub',
        signalrClientId: '52facf19-6786-4ff6-925d-5d7117e70273',
        signalrApiUrl: 'https://devnext.virtusllc.net/SignalR/api',
      },
      b2c: {
        appName: 'Virtus Admin Web App',
        clientId: 'e430a325-a6f1-4740-85c2-c6113784b30b',
        tenantId: 'devvirtuswebportal',
        b2cSigninPolicy: 'B2C_1_VirtusAdminWeb',
        b2cCredentialResetPolicy: 'B2C_1_passwordReset1',
        userLoginApiUrl: 'https://devnext.virtusllc.net/UserLoginApi/api/UserLogin/DoLogin/',
        b2cScope: 'https://devvirtuswebportal.onmicrosoft.com/virtusadmin/user_impersonation',
      },
      aad: {
        appName: 'Virtus Admin Web App',
        clientId: '6898c080-9396-43f0-abe0-3a359760a8c6',
        userLoginApiUrl: 'https://devnext.virtusllc.net/UserLoginApi/api/UserLogin/DoLogin/',
        tenantId: 'e3ff91d8-34c8-4b15-a0b4-18910a6ac575',
      },
      idp: {
        baseURL: 'https://infinity.dev.fiscloudservices.com/idp',
        firm: 'ConnectDev',
        clientId: 'virtusadminweb',
        clientSecret: '',
        responseType: 'code',
        scope: 'openid',
        clientEnvironment: 'virtusadminweb-dev',
        serviceProviderId: 'virtusadminweb-dev',
        refreshTokenInterval: 30 * 60 * 1000,
        appName: 'Virtus Admin Web App',
        userLoginApiUrl: 'https://devnext.virtusllc.net/UserLoginApi/api/UserLogin/DoLogin/',
        apiUrl: 'https://devnext.virtusllc.net/VirtusAdminAppApi',
        signalrUrl: 'https://devnext.virtusllc.net/SignalR/SignalRHub',
        signalrApiUrl: 'https://devnext.virtusllc.net/SignalR/api',
      },      
      defaultProfile: {
        DefaultGridRows: 25,
        DefaultTimeRange: 'P24H',
        DefaultUseSignalR: false,
      },
      appInsightsKey: '',
      unauthorizedTextMessage: 'You are not authorized to use this application. Please contact Virtus Support if you require assistance.',
      storageAccount: 'deveus2devopsstorage',
      container: '$web',
    };
  }

  if (__ENVIRONMENT__ === 'qa') {
    return {
      useIDP: false,
      useAD: true,
      adminConfig: {
        baseURL: 'https://stgnext.virtusllc.net/VirtusAdminAppApi',
        signalrUrl: 'https://stgnext.virtusllc.net/SignalR/SignalRHub',
        signalrClientId: 'a0ebfe2d-9a90-444c-ba5d-22d2848f27bf',
        signalrApiUrl: 'https://stgnext.virtusllc.net/SignalR/api',
      },
      b2c: {
        appName: 'Virtus Admin Web App staging',
        clientId: '74905752-20e7-46e6-9266-0a60b306b481',
        tenantId: 'stagingvirtuswebportal',
        b2cSigninPolicy: 'B2C_1_VirtusAdminWeb',
        b2cCredentialResetPolicy: 'B2C_1_passwordReset1',
        userLoginApiUrl: 'https://stgnext.virtusllc.net/UserLoginApi/api/UserLogin/DoLogin/',
        b2cScope: 'https://stagingvirtuswebportal.onmicrosoft.com/virtusadmin/user_impersonation',
      },
      aad: {
        appName: 'Virtus Admin Web App staging',
        clientId: '6898c080-9396-43f0-abe0-3a359760a8c6',
        userLoginApiUrl: 'https://stgnext.virtusllc.net/UserLoginApi/api/UserLogin/DoLogin/',
        tenantId: 'e3ff91d8-34c8-4b15-a0b4-18910a6ac575',
      },
      idp: {
        baseURL: 'https://infinity.dev.fiscloudservices.com/idp',
        firm: 'ConnectDev',
        clientId: 'virtusadminweb',
        clientSecret: '',
        responseType: 'code',
        scope: 'openid',
        clientEnvironment: 'virtusadminweb-dev',
        serviceProviderId: 'virtusadminweb-dev',
        refreshTokenInterval: 30 * 60 * 1000,
        appName: 'Virtus Admin Web App',
        userLoginApiUrl: 'https://stgnext.virtusllc.net/UserLoginApi/api/UserLogin/DoLogin/',
        apiUrl: 'https://stgnext.virtusllc.net/VirtusAdminAppApi',
        signalrUrl: 'https://stgnext.virtusllc.net/SignalR/SignalRHub',
        signalrApiUrl: 'https://stgnext.virtusllc.net/SignalR/api',
      },  
      defaultProfile: {
        DefaultGridRows: 25,
        DefaultTimeRange: 'P24H',
        DefaultUseSignalR: false,
      },
      appInsightsKey: '',
      unauthorizedTextMessage: 'You are not authorized to use this application. Please contact Virtus Support if you require assistance.',
      storageAccount: 'deveus2devopsstorage',
      container: '$web',
    };
  }

  if (__ENVIRONMENT__ === 'prod') {
    return {
      useIDP: false,
      useAD: true,
      adminConfig: {
        baseURL: 'https://next.virtusllc.net/VirtusAdminAppApi',
        signalrUrl: 'https://next.virtusllc.net/SignalR/SignalRHub',
        signalrClientId: 'a0ebfe2d-9a90-444c-ba5d-22d2848f27bf',
        signalrApiUrl: 'https://next.virtusllc.net/SignalR/api',
      },
      b2c: {
        appName: 'VirtusAdmin',
        clientId: '93574a9a-3522-41b5-af62-b8a3b5f0a2e8',
        tenantId: 'prodvirtuswebportal',
        b2cSigninPolicy: 'B2C_1_VirtusAdminWeb',
        b2cCredentialResetPolicy: 'B2C_1_passwordReset1',
        userLoginApiUrl: 'https://next.virtusllc.net/UserLoginApi/api/UserLogin/DoLogin/',
        b2cScope: 'https://ProdVirtusWebPortal.onmicrosoft.com/virtusadmin/user_impersonation',
      },
      aad: {
        appName: 'VirtusAdmin',
        clientId: '6898c080-9396-43f0-abe0-3a359760a8c6',
        userLoginApiUrl: 'https://next.virtusllc.net/UserLoginApi/api/UserLogin/DoLogin/',
        tenantId: 'e3ff91d8-34c8-4b15-a0b4-18910a6ac575',
      },
      idp: {
        baseURL: 'https://infinity.dev.fiscloudservices.com/idp',
        firm: 'ConnectDev',
        clientId: 'virtusadminweb',
        clientSecret: '',
        responseType: 'code',
        scope: 'openid',
        clientEnvironment: 'virtusadminweb-dev',
        serviceProviderId: 'virtusadminweb-dev',
        refreshTokenInterval: 30 * 60 * 1000,
        appName: 'Virtus Admin Web App',
        userLoginApiUrl: 'https://next.virtusllc.net/UserLoginApi/api/UserLogin/DoLogin/',
        apiUrl: 'https://next.virtusllc.net/VirtusAdminAppApi',
        signalrUrl: 'https://next.virtusllc.net/SignalR/SignalRHub',
        signalrApiUrl: 'https://next.virtusllc.net/SignalR/api',
      }, 
      defaultProfile: {
        DefaultGridRows: 25,
        DefaultTimeRange: 'P24H',
        DefaultUseSignalR: false,
      },
      appInsightsKey: '',
      unauthorizedTextMessage: 'You are not authorized to use this application. Please contact Virtus Support if you require assistance.',
      storageAccount: 'deveus2devopsstorage',
      container: '$web',
    };
  }

  throw new Error(`No config for __ENVIRONMENT__: '${__ENVIRONMENT__}'`);
};

const config = getConfig();
export default config;
